var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_RESELLERS) && _vm.reseller)?_c('div',[_c('router-link',{attrs:{"to":{ name: 'View Reseller', params: { id: _vm.reseller.id } }}},[_vm._v(" "+_vm._s(`${_vm.reseller.name}`)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }